import React from 'react';
import './SubTitle.scss'
export interface UHCSidebarSubTitleProps{
    text:string
}

export const UHCSidebarSubTitle: React.FC<UHCSidebarSubTitleProps> = (props: UHCSidebarSubTitleProps) => {
    return(
        <span className="sidebar-subtitle">{props.text}</span>
    )
}
